export function parsePurchaseUnit(int) {
  let purchaseUnit = ''
  switch (int) {
    case 10030:
      purchaseUnit = '克(g)'
      break
    case 10031:
      purchaseUnit = '千克(kg)'
      break
    case 10032:
      purchaseUnit = '毫升(mL)'
      break
    case 10033:
      purchaseUnit = '升(L)'
      break
    case 10034:
      purchaseUnit = '吨'
      break
    case 10035:
      purchaseUnit = '其他'
      break
    case 10036:
      purchaseUnit = '只'
      break
    case 10037:
      purchaseUnit = '头'
      break
    case 10038:
      purchaseUnit = '支'
      break
    case 10039:
      purchaseUnit = '袋'
      break
    case 10040:
      purchaseUnit = '尾'
      break
    case 10011:
      purchaseUnit = '斤'
      break
    case 10012:
      purchaseUnit = '公斤'
      break
    case 10013:
      purchaseUnit = '尾'
      break
  }

  return purchaseUnit
}

// 入市销售100501；流程销售100502
export function xiaoshoutype(int) {
  let batchSource = ''
  switch (int) {
    case 100501:
      batchSource = '入市销售'
      break
    case 100502:
      batchSource = '流程销售'
      break
  }

  return batchSource
}

export function parseBatchSource(int) {
  let batchSource = ''
  switch (int) {
    case 100201:
      batchSource = '自产'
      break
    case 100202:
      batchSource = '采购'
      break
  }

  return batchSource
}

export function parseMassifUnite(int) {
  let massifUnit = ''
  switch (int) {
    case 10016:
      massifUnit = '亩'
      break
    case 10017:
      massifUnit = '平方米'
      break
  }

  return massifUnit
}

export function FMTUNIT(value) {
  switch (value) {
    case 10030:
      return '克(g）'
    case 10031:
      return '千克(kg)'
    case 10032:
      return '毫升(ML)'
    case 10033:
      return '升(L)'
    case 10034:
      return '吨'
    case 10035:
      return '其他'
    case 10036:
      return '只'
    case 10037:
      return '头'
    case 10011:
      return '斤'
    case 10012:
      return '公斤'
    case 10013:
      return '尾'
  }
}

// 投喂: 300101 增氧: 300102 加水: 300103 清淤: 300104 疫苗: 300105 渔药: 300106 鱼苗: 300107  其他: 300108
export function FMTYANGZHI(value) {
  switch (value) {
    case 300101:
      return '投喂'
    case 300102:
      return '增氧'
    case 300103:
      return '加水'
    case 300104:
      return '清淤'
    case 300106:
      return '渔药'
    case 300107:
      return '鱼苗'
    case 300108:
      return '其他'
  }
}

// （禽畜养殖类别1020100禽畜养殖类别；1020101投喂； 1020102清洁； 1020103防疫 *; 1020104 消毒；1020105投药 *；1020106投幼崽 *；1020107其它；）
export function FMTXUQINYANGZHI(value) {
  switch (value) {
    case 1020101:
      return '投喂'
    case 1020102:
      return '清洁'
    case 1020103:
      return '防疫'
    case 1020104:
      return '消毒'
    case 1020105:
      return '投药'
    case 1020106:
      return '投幼崽'
    case 1020107:
      return '其他'
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js